import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { useId } from 'react-id-generator';
import { jsx } from 'react/jsx-runtime';

var Context = /*#__PURE__*/React.createContext(null);

var AccordionContext = function AccordionContext(_ref) {
  var children = _ref.children,
      defaultIndex = _ref.defaultIndex;

  var _React$useState = React.useState(defaultIndex || []),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      openPanels = _React$useState2[0],
      setOpenPanels = _React$useState2[1];

  var onSelect = React.useCallback(function (index) {
    setOpenPanels(function (prevOpenPanels) {
      return prevOpenPanels.includes(index) ? prevOpenPanels.filter(function (i) {
        return i !== index;
      }) : [].concat(_toConsumableArray(prevOpenPanels), [index]);
    });
  }, []);

  var _useId = useId(1, "accordion-"),
      _useId2 = _slicedToArray(_useId, 1),
      id = _useId2[0];

  var context = React.useMemo(function () {
    return {
      accordionId: id,
      defaultIndex: defaultIndex,
      onSelect: onSelect,
      openPanels: openPanels
    };
  }, [id, defaultIndex, onSelect, openPanels]);
  return /*#__PURE__*/jsx(Context.Provider, {
    value: context,
    children: children
  });
};

AccordionContext.propTypes = {
  "children": _PropTypes.node,
  "defaultIndex": _PropTypes.arrayOf(_PropTypes.number)
};
AccordionContext.displayName = "AccordionContext";
function useAccordionContext() {
  var accordionContext = React.useContext(Context);

  if (!accordionContext) {
    throw new TypeError("No AccordionContext provided");
  }

  return accordionContext;
}

export { AccordionContext, useAccordionContext };
